import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AbilityRangeGenerator } from '../../../../utils/AssessmentUtil';

class Distortion extends Component {
  render() {
    const { distortion } = this.props;

    if (!distortion) {
      return <div />;
    }

    const abilityRange = AbilityRangeGenerator.generateRangeContainer(distortion);

    return (
      <div className="ability">
        {abilityRange}
      </div>
    );
  }
}

Distortion.propTypes = {
  distortion: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Distortion;
